export default [
  // 学员电子钱包明细按校区展示弹窗
  {
    // 欠交
    name: 'student-own-fee',
    component: () => import(/* webpackChunkName: "StudentOwnFee" */ './student-own-fee.vue'),
  },
  {
    // 待付款
    name: 'student-awaiting-payment',
    component: () => import(/* webpackChunkName: "StudentAwaitingPayment" */ './student-awaiting-payment.vue'),
  },
  {
    // 课时包
    name: 'lesplan-chooser',
    component: () => import(/* webpackChunkName: "LesplanChoose" */ './lesplan-chooser.vue'),
  },
];
